import React from 'react'
import { useStyles } from './Styles'
import { DashboardProvider, DashboardConsumer } from '../../context/DashboardContext'
import { FormattedMessage } from 'react-intl'
import PageTitle from '../PageTitle'
import AddNewForm from '../../FormFields/EntityAddForm'
import AddNewDialog from '../Dialog/AddNewDialog'
import { Button } from '@material-ui/core'
import EventIcon from '@material-ui/icons/Event'
import AmountBox from './AmountBox'
import StatesBox from './StatesBox'
import Moment from 'react-moment'
import { LanguageConsumer } from '../../context/LanguageContext'
import moment from 'moment'
import 'moment/locale/ar-sa'

const HomePageContent = () => {
  const classes = useStyles()
  return (
    <LanguageConsumer>
      {({ locale }) => (
        <DashboardProvider>
          <DashboardConsumer>
            {({
                dashboardIssuerLoading, dashboardReceiverLoading, updateDashboard, dashboardIssuerData, dashboardReceiverData, isDialogOpen, openDialog,
                cancelDialog, filterData
              }) => (
              <>
                <PageTitle title={<FormattedMessage id='DashboardPageContent.PageTitle'/>}
                           subTitle={<FormattedMessage id='DashboardPageContent.PageDisclaimer'/>}
                           wrap
                           extraButtons={
                             <div className={classes.activityWrapper}><label><FormattedMessage
                               id={'dashboard.filter.label'}/></label>
                               <Button size={'medium'} variant={'text'} color={'primary'} onClick={openDialog}
                                       className={classes.backBtn} disableRipple disableElevation>
                                 <EventIcon/> <Moment className={classes.activityDate}
                                                      locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                                                      format="DD-MM-YYYY">{filterData?.dateFrom}</Moment> — <Moment
                                 className={classes.activityDate}
                                 locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                                 format="DD-MM-YYYY">{moment.min(moment(filterData?.dateTo).locale(locale === 'ar' ? 'ar-sa' : 'en-us'), moment().locale(locale === 'ar' ? 'ar-sa' : 'en-us'))}</Moment>
                               </Button></div>
                           }/>

                <AddNewDialog
                  children={
                    <AddNewForm
                      currentData={filterData}
                      entityName={'dashboard'}
                      onSubmit={updateDashboard}
                      cancelDialog={cancelDialog}/>
                  }
                  dialogAction={'filter'}
                  DialogTitle={<FormattedMessage id={'dashboard.dialogTitle.filter'}/>}
                  isDialogOpen={isDialogOpen}
                  cancelDialog={cancelDialog}
                />
                <div className={classes.dashboardWrapper}>
                  <AmountBox issuer amounts={dashboardIssuerData[0]?.amounts} loading={dashboardIssuerLoading}/>
                  <AmountBox amounts={dashboardReceiverData[0]?.amounts} loading={dashboardReceiverLoading}/>

                  <StatesBox issuer states={dashboardIssuerData[0]?.stats} loading={dashboardIssuerLoading}/>
                  <StatesBox states={dashboardReceiverData[0]?.stats} loading={dashboardReceiverLoading}/>
                </div>
              </>
            )}
          </DashboardConsumer>
        </DashboardProvider>
      )}
    </LanguageConsumer>

  )
}

export default HomePageContent
